import { render, staticRenderFns } from "./AdminDataModuleForm.vue?vue&type=template&id=e6eb5d30"
import script from "./AdminDataModuleForm.vue?vue&type=script&lang=js"
export * from "./AdminDataModuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports